import React from 'react';

import config from '../../config';
import InAppStore from '../../stores/InAppStore';
import appVersion from '../../appVersion';
import { deviceDetection } from '../../helpers/DeviceDetection';

const SECRET_TIME_WINDOW_MS = 2000;

const secretStates = {
    IDLE: 'IDLE',
    LEFT_TRIGGERED: 'LEFT_TRIGGERED',
    RIGHT_TRIGGERED: 'RIGHT_TRIGGERED',
    SHOW: 'SHOW'
};

class SecretVersion extends React.PureComponent {
    state = {
        secretVersion: secretStates.IDLE,
        timeoutId: null
    };

    componentWillUnmount() {
        clearTimeout(this.state.timeoutId);
    }

    _handleSecret = ({ isLeftBox }) => e => {
        const { secretVersion, timeoutId } = this.state;
        e.preventDefault();

        let nextState = secretStates.IDLE;

        switch (secretVersion) {
            case secretStates.IDLE:
                if (isLeftBox) {
                    nextState = secretStates.LEFT_TRIGGERED;
                    this.setState({
                        timeoutId: setTimeout(() => this.setState({ secretVersion: secretStates.IDLE }), SECRET_TIME_WINDOW_MS)
                    });
                }
                break;

            case secretStates.LEFT_TRIGGERED:
                if (!isLeftBox) {
                    nextState = secretStates.RIGHT_TRIGGERED;
                }
                break;

            case secretStates.RIGHT_TRIGGERED:
                if (isLeftBox) {
                    nextState = secretStates.SHOW;
                    clearTimeout(timeoutId);
                }
                break;
        }

        this.setState({ secretVersion: nextState });
    }

    render() {
        const { secretVersion } = this.state;

        if (!InAppStore.isInApp()) {
            return null;
        }

        return (
            <div className="secret-version">
                <div className="secret-version__box" onClick={ this._handleSecret({ isLeftBox: true }) }>
                    { secretVersion === secretStates.SHOW &&
                        <dl className="secret-version__box__list">
                            <dt>App:</dt><dd>{ InAppStore.getAppVersion() }</dd>
                            <dt>BEng:</dt><dd>{ appVersion && appVersion.version }</dd>
                            <dt>Host:</dt><dd>{ `${window.location.protocol}//${window.location.host}` }</dd>
                            <dt>Path:</dt><dd>{ window.location.pathname }</dd>
                            <dt>Device:</dt><dd>{ deviceDetection() }</dd>
                            <dt>UA:</dt><dd>{ window.navigator.userAgent }</dd>
                            <dt>Extra:</dt><dd>{ config.get('extraInfoSecretVersion') }</dd>
                        </dl> }
                </div>
                <div className="secret-version__box" onClick={ this._handleSecret({ isLeftBox: false }) }/>
            </div>
        );
    }
}

export default SecretVersion;



// WEBPACK FOOTER //
// ./src/components/inApp/SecretVersion.js